module.exports = __webpack_public_path__ + "static/media/vinyl.ab2ec768.png";